import ApiService from "@/core/services/api/v2/api.service";

const RegisterService = {
  register(registerData) {
    return new Promise(resolve => {
      ApiService.post("register", registerData)
        .then(response => {
          // Return full response data, because it may hold payment info
          resolve(response.data.response);
        })
        .catch(error => {
          resolve(error.response.status);
        });
    });
  }
};

export default RegisterService;
